export default {
    data () {
        return {
            type: '',
            // 权利人信息
            rightsInfo: {},
            // 证书信息
            certificateInfo: {},
            // 作品基本信息
            basicInfo: {},
            // 制作团队
            productionTeam: {},
            // 创作过程认证
            createProcessList: [],
        }
    },
    methods: {
        // 处理详情数据
        detailHandleData (data = {}) {
            // 0 是通用 1 是短剧漫剧
            this.type = data['type']
            let rightsInfoColum = [ 'applicant', 'owner', 'applicantDeclaration' ]
            let rightsInfo = {}
            rightsInfoColum.map(item => {
                rightsInfo[item] = data[item]
            })
            this.rightsInfo = rightsInfo

            let certificateInfoColum = [ 'certStorePathUrl', 'certThumbnailStorePathUrl', 'enCertThumbnailStorePathUrl']
            let certificateInfo = {}
            certificateInfoColum.map(item => {
                certificateInfo[item] = data[item]
            })
            this.certificateInfo = certificateInfo

            let basicInfoColum = [ 'type', 'name', 'description', 'totalEpisodes', 'genre', 'categoryIds', 'categoryNames', 'category', 'setupStatus', 'randomKey', 'accessStatus', 'setupDuration', 'accessCode', 'setupExpiredAt' ]
            let basicInfo = {}
            let productionTeamColum = [ 'productionCompany', 'producer', 'director', 'actors', 'productionCost']
            let productionTeam = {}
            
            let createProcessList = []
            basicInfoColum.map(item => {
                basicInfo[item] = data[item]
            })
            this.basicInfo = basicInfo
            productionTeamColum.map(item => {
                productionTeam[item] = data[item]
            })
            this.productionTeam = productionTeam
            // 草稿阶段
            data['dramaStageDraftList'] && data['dramaStageDraftList'].map(item => {
                let obj = {
                    id: item['dramaDraftId'],
                    fileNum: item['fileNum'] || 0,
                    name: item['name'],
                    tipCode: item['tipCode'],
                    children: [],
                    isFold: true,
                }
                
                item.dramaStageFileDraftList && item.dramaStageFileDraftList.map(item2 => {
                    obj.children.push(item2)
                })
                createProcessList.push(obj)
            })
            data['stages'] && data['stages'].map(item => {
                let obj = {
                    id: item['stageId'],
                    fileNum: item['fileNum'] || 0,
                    name: item['name'],
                    tipCode: item['tipCode'],
                    children: [],
                    isFold: true,
                }
                
                item.dramaStageFileList && item.dramaStageFileList.map(item2 => {
                    obj.children.push(item2)
                })
                createProcessList.push(obj)
            })
            
            this.createProcessList = createProcessList
        },
    }
}